import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {WMSContext} from "../../../context/WMSContext";
import RightDrawerDesktop from "../../../../../components/WMS/Desktop/RightDrawerDesktop";
import {FormattedMessage} from "react-intl";
import {BeatLoader} from "react-spinners";
import {Grid} from "@mui/material";
import ExpeditionListViewItem from "./component/ExpeditionListViewItem";
import {blueColor} from "../../../../../assets/jss/main";
import {listExpeditionList} from "../../../../../api/expeditionList/list.j";
import BottomDrawer from "../../../../../components/WMS/Mobile/BottomDrawer";

ExpeditionListViewDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired
};

function ExpeditionListViewDrawer({open, handleClose}) {
    const [loading, setLoading] = useState(true)
    const [expeditionLists, setExpeditionLists] = useState([])

    const {currentInventory} = useContext(WMSContext)

    useEffect(() => {
        if (open) {
            listExpeditionList(currentInventory.id).then(response => {
                const sortedExpeditionList = [...response].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

                setExpeditionLists(sortedExpeditionList)
                setLoading(false)
            })
        }
    }, [open]);

    return (
        <BottomDrawer
            open={open}
            onClose={handleClose}
            title={<FormattedMessage id={"wms.shipping.expeditionList.title"}/>}
            openMaxHeight
            maxHeight={'50%'}
        >
            <Grid container padding={'16px'}>
                {loading && (
                    <Grid container justifyContent={"center"}>
                        <BeatLoader loading={loading} size={15} color={blueColor}/>
                    </Grid>
                )}

                {!loading && (
                    <Grid container direction={"column"} gap={'8px'}>
                        {expeditionLists.map(expeditionList => (
                            <ExpeditionListViewItem
                                key={expeditionList.id}
                                expeditionList={expeditionList}
                            />
                        ))}
                    </Grid>
                )}
            </Grid>
        </BottomDrawer>
    );
}

export default ExpeditionListViewDrawer;